import React from 'react';

import { ORGANIZATION_USERS_LIST_QUERY_KEY, UsersListPage } from '../../shared/users';

export const UsersList: React.FC = () => (
  <UsersListPage
    queryKeyBase={ORGANIZATION_USERS_LIST_QUERY_KEY}
    displayTypePrefKey="OrganizationUsers"
    pendingInvitationsRoute="/app/organization/pending-invitations"
    linkContext="organization"
  />
);
